import React from 'react';
import { useRole } from "@/hooks/useRole";
import { Loader2 } from "lucide-react";
import { AccessDenied } from "@/components/admin/games/AccessDenied";
import FeaturedItemsManager from '@/components/admin/featured/FeaturedItemsManager';

const DestaquesAdmin: React.FC = () => {
  const { role, loading: roleLoading } = useRole();

  if (roleLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#0f141c] pt-16">
        <Loader2 className="h-12 w-12 text-[#00B6F0] animate-spin" />
      </div>
    );
  }

  if (role !== "admin") {
    return <AccessDenied />;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-white mb-2">
          Gerenciar Destaques
        </h1>
        <p className="text-gray-400">
          Configure quais mentorias, mentores e comunidades aparecem em destaque na plataforma
        </p>
      </div>
      
      <FeaturedItemsManager />
    </div>
  );
};

export default DestaquesAdmin; 